<template>
  <b-modal size="xl" hide-footer :id="id" content-class="p-4" @hidden="blankCurrentFilter">
    <!-- header -->
    <template v-slot:modal-title>
      <div class="title">
        <span>{{ value.title }}</span>
      </div>
      <div class="subTitle">
        <span>{{ value.subtitle }}</span>
      </div>
    </template>

    <!-- sub header -->
    <template>
      <div>
        <span class="font-weight-bold">{{ value.subHeader.number }}</span>
        {{ value.subHeader.label }}
      </div>

      <div class="text-grey mt-1">
        <span v-for="(label, index) in Object.keys(value.otherInfo)" :key="index">
          <span :class="value.labelDisplayClass">
            {{ value.otherInfo[label] }}
          </span>
        </span>
      </div>
    </template>

    <!-- search input -->
    <b-input-group class="searchBox mb-4 mt-3" size="sm">
      <b-input-group-text>
        <i class="fas fa-search"></i>
      </b-input-group-text>
      <b-input :placeholder="value.placeholder" v-model="filter"></b-input>
    </b-input-group>

    <!-- bv table -->
    <b-table
      class="pointer small"
      :items="value.items"
      :fields="value.fields"
      :filter="filter"
      no-sort-reset
      small
      striped
      sticky-header
      no-border-collapse
      @row-clicked="(item) => onClickTableRow(item)"
    ></b-table>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {},
    value: {},
  },

  data() {
    return {
      filter: '',
    }
  },

  methods: {
    blankCurrentFilter() {
      this.filter = ''
    },
    onClickTableRow(value) {
      this.$emit('on-click-table-row', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.title,
.subTitle {
  font-size: 0.9rem;
}

.text-grey {
  font-size: 0.8rem;
  color: var(--gray8);
}

.searchBox * {
  background-color: #f8f8f8 !important;
  margin: 0 -1px 0 -1px;
}

.searchBox input {
  border-left: 0;
}

.searchBox .input-group-text {
  border-right: 0;
}
</style>
